import React from 'react';
import { actions as modalActions } from 'redux/modal';

const showDownloadErrorModal = (dispatch, t) => {
  dispatch(
    modalActions.openModal(
      {
        size: 'small',
        title: t('errors.certificateDownloadFailed'),
      },
      <p>
        {t('errors.certificateDownloadFailedMessage') || 'Failed to download certificate. Please try again later.'}
      </p>,
    ),
  );
};

export const handleCertificateDownload = async ({
  certificate,
  courseId,
  userId,
  downloadCertificate,
  dispatch,
  t,
}) => {
  if (!certificate) {
    return false;
  }

  const previewUrl =
    typeof certificate === 'string'
      ? certificate
      : typeof certificate?.previewUrl === 'string'
      ? certificate.previewUrl
      : '';
  if (previewUrl) {
    return false;
  }

  const responseData = await downloadCertificate(courseId, userId);
  if (responseData && responseData.error) {
    showDownloadErrorModal(dispatch, t);
  }
  return true;
};
